'use strict'

//Import scss for compiling
import './../scss/components.scss'

//Other imports
import { toggleDarkMode } from './helpers'

jQuery(document).ready(function ($) {
    //Set theme mode
    // toggleDarkMode()
    
})